<template>
  <section>
    <country-list :query="query" />
  </section>
</template>

<script>
import CountryList from '@/components/basic/CountryList'

export default {
  name: 'Countries',
  components: {
    CountryList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
